export const PROJECT_NAME = "sleepdiary";
export const SITE_URL = "https://"+PROJECT_NAME+".github.io/";
export const PROJECT_URL = "https://github.com/"+PROJECT_NAME+"/";
export const DOCS_URL = "../docs/";
